import { render, staticRenderFns } from "./AamsRegSealEngraveApproval.vue?vue&type=template&id=5a0bf5dc&scoped=true&"
import script from "./AamsRegSealEngraveApproval.vue?vue&type=script&lang=js&"
export * from "./AamsRegSealEngraveApproval.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a0bf5dc",
  null
  
)

export default component.exports